'use client';

import cx from 'classix';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import {
  BsStarFill,
  BsStarHalf,
} from 'react-icons/bs';
import QRCode from 'react-qr-code';

import rootPageSharedStyles from '@/app/[locale]/root-page-share.module.scss';
import { getAppFlyerLink } from '@/features/roomster-app/hooks/use-app-flyer-link';
import { DOWNLOAD_APP_LINKS } from '@/shared/constants/links-constants';

import styles from './app-download-section.module.scss';

const fullStars = Array.from({ length: 4 }, (_, index) => index);

export default function AppDownloadSection() {
  const appDownloadSectionTranslates = useTranslations('home.app-download-section');
  const qrCodeLink = getAppFlyerLink('desktop', 'qrCode');

  return (
    <section className={cx(rootPageSharedStyles.section, styles.appDownloadSection)}>
      <div className={styles.appDownloadSection_imageCotainer}>
        <Image
          className={styles.appDownloadSection_image}
          src="/images/roomster-app/download-app-2.jpg"
          alt="dowload app image"
          fill
        />

        <div className={styles.appDownloadSection_content}>
          <h2 className={styles.appDownloadSection_title}>
            {appDownloadSectionTranslates('title')}
          </h2>
          <p className={styles.appDownloadSection_text}>
            {appDownloadSectionTranslates('text')}
          </p>

          <div className={styles.startContainer}>
            {fullStars.map((item) => (
              <div
                key={item}
                className={
                  styles.startContainer_item
                }
              >
                <BsStarFill />
              </div>
            ))}
            <div
              className={styles.startContainer_item}
            >
              <BsStarHalf />
            </div>
          </div>

          <div className={styles.appDownloadSection_actions}>
            <a
              aria-label="appStore"
              className={styles.appDownloadSection_storeLink}
              href={DOWNLOAD_APP_LINKS.appStore}
              rel="noreferrer"
            >
              <div className={styles.appDownloadSection_storeLinkImage}>
                <Image
                  src="/images/banner/tunes.png"
                  alt="full star"
                  fill
                  style={{ objectFit: 'contain' }}
                />
              </div>
            </a>

            <a
              aria-label="googlePlay"
              className={styles.appDownloadSection_storeLink}
              href={DOWNLOAD_APP_LINKS.googlePlay}
              rel="noreferrer"
              target="_blank"
            >
              <div className={styles.appDownloadSection_storeLinkImage}>
                <Image
                  src="/images/banner/google-play.png"
                  alt="full star"
                  fill
                  style={{ objectFit: 'contain' }}
                />
              </div>
            </a>

            <QRCode
              className={styles.appDownloadSection_qrcode}
              size={140}
              style={{
                height: 'auto',
                maxWidth: '100%',
                width: '100%',
              }}
              value={`${qrCodeLink.pathname}?${qrCodeLink.query}`}
              viewBox="0 0 140 140"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
